export default __webpack_public_path__ + "static/vos-jamell-d76c1f7f22aed66390c0f10ecbb7325a.mp4";